export default __webpack_public_path__ + "static/RootSans-7SemiBold-679e7611113e0be2002273a01434bbd6.woff";